(function () {

  'use strict';

  angular.module('eclipseApp.myAccount')

    .controller('orderDetailModalCtrl', ['$scope', '$rootScope', '$injector', '$http', '$modalInstance', 'headerTitle', 'orderId', 'uteEndpoint', 'uteModal', 'changeTechInstallService', '$state', '$translate', '$q', 'uteLocale','util', 'dtmService', 'dtmServiceConstants', function ($scope, $rootScope, $injector, $http, $modalInstance, headerTitle, orderId, uteEndpoint, uteModal, changeTechInstallService, $state, $translate, $q, uteLocale, util, dtmService, dtmServiceConstants) {

      $scope.hasTechInstallAppointment = 'LOADING';
      $scope.hasError = false;
      $scope.canViewChangeAppointment = null;

      var internetAcct = _.filter($rootScope.userInfo.accounts, function (account) {
        return (account.serviceName === 'Internet/TV' || account.serviceName === 'Internet');
      });

      if (internetAcct && (internetAcct || []).length > 0) {
        var accNum = internetAcct[0].accountNumber;
      }

      var api = {
        //getOrderDetail: 'http://localhost:8888/resource/getOrderDetail.json',
        getOrderDetail: uteEndpoint('v1/getOrderDetail')
      };

      util.setCacheVariable('internetSelectedAccountNumber',accNum);

      $http.post(api.getOrderDetail, {
        orderID: orderId,
        accountNumber: accNum
      }).success(function (data, status, headers, config) {

        var isAgent = $rootScope.ruiMethods.user.is.agent();

        if (data.productInfo.error == '') {

          /*
           * @description handle showing 'View/ Change Appointment' link only if:
           * actionType = PROVIDE && fulfillmentOption = TP or
           * actionType = CEASED && fulfillmentOptionn = TN
           *
           */
          $scope.canViewChangeAppointment = changeTechInstallService.parseOrderDetailForEligibleFulfillmentOption(data);
          if ($scope.canViewChangeAppointment) {
            /*
             * @method changeTechInstallService.getViewInstallationAppointment
             * @description handle fetch user current installation appointment
             */
            changeTechInstallService.getViewInstallationAppointment().then(
              function (successResp) {

                var respObjectKey = 'getCurrentTechInstallAppointment';

                if (successResp.data &&
                  successResp.data[respObjectKey] &&
                  successResp.data[respObjectKey].error) {

                  /*
                   * @if
                   * @description handle response with error
                   */

                  $scope.hasTechInstallAppointment = 'ERROR';
                  return;

                }

                /*
                 * @description handle has appointment
                 */
                changeTechInstallService.currentTechInstallAppointment = successResp.data[respObjectKey];

                $scope.hasTechInstallAppointment = 'TRUE';
              },
              function (errResp) {

                /*
                 * @callback reject http response
                 * @description handle http failuer
                 */
                $scope.hasTechInstallAppointment = 'ERROR';

              });
          } else {
            $scope.hasTechInstallAppointment = 'CANT_CHANGE';
          }

          //Add fulfillmentCode Keys
          _.map(data.productInfo.services, function (service) {
            $scope.parseFulfillmentCode(service.actionType.toLowerCase(), service.fulfillmentOption.toLowerCase(), service.productName.toLowerCase(), isAgent).then(function (key) {
              service.fulfullmentCodeDesc = key;
            });
            $scope.parseActionTypeCode(service.actionType.toLowerCase(), isAgent).then(function (key) {
              service.actionTypeCodeDesc = key;
            });
            //Add if we need to show link to cfa
            service.isLink = $scope.showFulfillmentLink(isAgent, service.actionType.toLowerCase(), service.fulfillmentOption.toLowerCase(), service.productName.toLowerCase());
          });

          $scope.mockData = data;
        }
        else {
          $scope.hasError = true;
        }
      }).error(function (data, status, headers, config) {
        $scope.hasError = true;
        $scope.hasTechInstallAppointment = 'ERROR';
      });

      $scope.ok = function () {
        $modalInstance.close();
      };

      $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
      };

      $scope.headerTitle = headerTitle;

      $scope.displayModemOperationModal = function (action) {
        var actionCode;
        if (action && action.match(/provide/i) || action.match(/provide-in-replace-offer/i)) {
          actionCode = 'pickup-modem';
        } else if (action && action.match(/exchange/i) || action.match(/swap/i)) {
          actionCode = 'exchange-modem';
        } else if (action && (action.match(/cease/i) || action.match(/equipment_pickup_and_return/i))) {
          actionCode = 'return-modem';
        } else {
          // no action on unknown action strings
          return;
        }

        $scope.returnModemModal = uteModal.open({
          templateUrl: 'views/templates/modal/self-serve-modem-modal.html',
          controller: 'selfServeModemCtrl',
          resolve: {
            action: actionCode,
            orderId: orderId
          }
        });

      };

      $scope.parseFulfillmentCode = function (actionType, fulfillmentCode, productName, isAgent) {
        var deferred = $q.defer();
        var transKey;
        if (isAgent === true) {
          transKey = 'retail.label.' + productName + "." + actionType + "." + fulfillmentCode;
        }
        else {
          transKey = 'global.label.' + productName + "." + actionType + "." + fulfillmentCode;
        }

        $translate(transKey).then(function (key) {
          deferred.resolve(key);
        }, function (error) {
          //Show default key in case key is not found, currently blank
          //$translate('global.label.unknown').then(function (defaultKey){
          //  deferred.resolve(defaultKey);
          //});
          deferred.resolve('');
        });
        return deferred.promise;
      };

      $scope.parseActionTypeCode = function (actionType, isAgent) {
        var deferred = $q.defer();
        var transKey;
        if (isAgent === true) {
          transKey = 'retail.label.modem.actionType.' + actionType;
        }
        else {
          transKey = 'global.label.modem.actionType.' + actionType;
        }

        $translate(transKey).then(function (key) {
          deferred.resolve(key);
        }, function (error) {
          //Show default key in case key is not found, currently blank
          //$translate('global.label.unknown').then(function (defaultKey){
          //  deferred.resolve(defaultKey);
          //});
          deferred.resolve('');
        });
        return deferred.promise;
      };

      //Show link for fulfillment or just text
      $scope.showFulfillmentLink = function (isAgent, actionType, fulfillmentCode, productName) {
        if (productName === 'modem' && isAgent) {
          if ((fulfillmentCode === 're') && (actionType === 'cease' || actionType === 'provide' || actionType === 'equipment_pickup_and_return' || actionType === 'provide-in-replace-offer' || actionType === 'swap')) {
            return true;
          }
        }
        return false;
      };

      $scope.changeTechAppt = function (selectedAccountNumber) {
        dtmService.start(dtmServiceConstants.dtmRules.changeAppointment.name, dtmServiceConstants.type.active, dtmServiceConstants.actions.startEvent);
        uteModal.open({
          templateUrl: 'modules/my-account/internet/change-appointment-modal.html',
          size: 'lg',
          controller: ['changeTechInstallService', '$scope', '$state', function (changeTechInstallService, $scope, $state) {

            $scope.currentTechInstallAppointment = changeTechInstallService.currentTechInstallAppointment;
            $scope.loadError = !$scope.currentTechInstallAppointment;
            $scope.selectedAccountNumber=$scope.selectedAccountNumber;

            $scope.submitChangeAppointment = function () {
              $state.params.selectedAccountNumber=$scope.selectedAccountNumber;

              $state.go('myAccount.internet.changeTechInstall', $state.params);
            };

            $scope.language = uteLocale.language;

          }]
        });
      };


    }]);

})();
